import React from 'react';

const Preloader = ({ visible }) => {
	// Do not show preloader if not needed
	if (!visible) return null;

	return (
		<div className="fixed top-0 right-0 bottom-0 left-0 z-50 flex justify-center items-center bg-neutral-50 dark:bg-neutral-900">
			<div>Lūdzu uzgaidiet!</div>
			<div>Pārbaudām, vai jūsu pieejas dati ir valīdi.</div>
		</div>
	);
};

export default Preloader;
